<template>
  <div id="help-login-description" class="help">
    <call />
    <!-- header -->
    <top-bar title="ヘルプ" backUrl="/help/login"/>
    <!-- main -->
    <main>
      <footer-app page="top" :loading="loading"></footer-app>
      <section>
        <div class="l-main--bg-border l-main--bg-border--pink">
          <div class="l-main__body">
            <div class="l-check-cart">
              <div class="l-check-cart__head min-h-100">
                <div class="l-check-cart__title text-left">アカウント連携</div>
                <div class="font-size-16">
                  アプリは、アカウント連携しなくても利用可能ですが、アカウント連携していただくとより便利な機能がご利用いただけます。
                </div>
                <div class="help-card mt-24">
                  <div class="font-size-17 font-bold text-left">アカウント連携すると利用できる機能</div>
                  <div>
                    <ul>
                      <li>クーポン</li>
                      <li>抽選会</li>
                      <li>アンケート</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <button-back />
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import TopBar from "../components/TopBar.vue";
import Footer from "../components/Footer.vue";
import ButtonBack from "../components/ButtonBack.vue";

export default Vue.extend({
  name: "HelpLoginDescription",
  components: {
    TopBar,
    FooterApp: Footer,
    ButtonBack,
  },
  mixins: [Tenant],
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async init() {
      Common.vueInitFunc(this);
      this.loading = false;
    },
  },
});
</script>